<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Edit Upcomming Drives">
      <div class="row">
        <div class="col-md-6 form-group">
          Name
          <input
            class="form-control"
            type="text"
            v-model="name"
            @focus="nameEmpty = false"
          />
          <div v-if="nameEmpty" style="color: red">Name is required</div>
        </div>
        <div class="col-md-6 form-group">
          Start Date
          <b-form-datepicker
            v-model="startDate"
            @input="startDateEmpty = false"
          ></b-form-datepicker>
          <div v-if="startDateEmpty" style="color: red">
            start date is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Image
          <b-form-file
            id="file-small"
            v-model="image"
            @change="(imageEmpty = false), (image = $event.target.files[0])"
          ></b-form-file>
          <div v-if="imageEmpty" style="color: red">image is required</div>
        </div>
        <div class="col-md-6 form-group">
          Subscription
          <b-form-select
            v-model="subscription"
            @change="subscriptionEmpty = false"
          >
            <option
              v-for="(subscription, index) in subscriptionOptions"
              :key="index"
              :value="subscription.id"
            >
              {{ subscription.name }}
            </option>
          </b-form-select>
          <div v-if="subscriptionEmpty" style="color: red">
            subscription is required
          </div>
        </div>
      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          @click="saveChanges()"
          >Save Changes</b-button
        >
      </div>
        <!-- Loader -->
        <b-overlay :show="loader" no-wrap blur="2px" opacity="0.60" class="position-fixed">
          <template #overlay>
            <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
          </template>
        </b-overlay>
    </base-block>
    <br />
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      id: "",
      loader: false,
      nameEmpty: false,
      startDateEmpty: false,
      imageEmpty: false,
      subscriptionEmpty: false,
      name: "",
      image: [],
      startDate: "",
      subscription: "",
      subscriptionOptions: [],
    };
  },
  mounted() {
    this.getSubscriptions();
    this.loadData();
  },
  methods: {
    async saveChanges() {
        console.log(this.id);
      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }
      if (this.startDate == "") {
        this.startDateEmpty = true;
        return;
      }
      if (this.image == "") {
        this.imageEmpty = true;
        return;
      }
      if (this.subscription == "") {
        this.subscriptionEmpty = true;
        return;
      }
       this.loader = true;
      const formdata = new FormData();
      formdata.append("name", this.name);
      formdata.append("image", this.image);
      formdata.append("type", "upcoming");
      formdata.append("date", this.startDate);
      formdata.append("subscription_id", this.subscription);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/recruitment-drives/upcoming-update/${this.id}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.loader = false;
            this.$swal(
              "Success",
              "Upcomming drive updated successfully",
              "success"
            );
             this.$router.push({name: 'Upcomming Drives'});
            this.name = "";
            (this.image = []),
              (this.startDate = ""),
              (this.subscription = ""),
              (this.nameEmpty = false),
              (this.imageEmpty = false),
              (this.startDateEmpty = false),
              (this.subscriptionEmpty = false);
          } else {
             this.loader = false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
           this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getSubscriptions() {
      await axios
        .get(`${this.$store.getters.baseUrl}/subscriptions`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.subscriptionOptions = response.data.subscriptions;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async loadData() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/recruitment-drives/upcoming-edit/${this.$route.params.id}`,
          {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
          }
        )
        .then((response) => {
          console.log("loadData", response);
          if (response.data.status == "success") {
            this.id = response.data.drive.id;
            this.name = response.data.drive.name;
            this.startDate = response.data.drive.date;
            this.image = response.data.drive.image;
            this.subscription = response.data.drive.subscription_id;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>

